import { useState, useMemo, useRef, useEffect } from "react";

/* ------------------------------------------------------------------
   1. Translation table — ported 1:1 from the Python TRANSLATIONS dict.
      Add a new language by adding one more key here + to LANGUAGE_NAMES.
------------------------------------------------------------------- */
const TRANSLATIONS = {
  en: { hello: "Hello {name},", thanks: "Thank you — you are interested.", consent_type: "Consent Type:", consent_version: "Consent Version:", id_proof: "ID Proof:", not_provided: "Not provided", accept: "Accept", decline: "Decline", fallback_link_note: "If the buttons above don't work, copy and paste this link into your browser:", accept_label: "Accept:", decline_label: "Decline:", best_regards: "Best regards,", info_only: "This message is provided for your information and does not include response buttons.", status_pending: "Awaiting your response", status_accepted: "Accepted", status_declined: "Declined", eyebrow: "Consent Request" },
  hi: { hello: "नमस्ते {name},", thanks: "धन्यवाद — आपने रुचि दिखाई है।", consent_type: "सहमति प्रकार:", consent_version: "सहमति संस्करण:", id_proof: "पहचान प्रमाण:", not_provided: "प्रदान नहीं किया गया", accept: "स्वीकार करें", decline: "अस्वीकार करें", fallback_link_note: "यदि ऊपर दिए गए बटन काम नहीं करते हैं, तो इस लिंक को कॉपी करके अपने ब्राउज़र में पेस्ट करें:", accept_label: "स्वीकार करें:", decline_label: "अस्वीकार करें:", best_regards: "सादर,", info_only: "यह संदेश केवल सूचना के लिए है और इसमें प्रतिक्रिया बटन शामिल नहीं हैं।", status_pending: "आपकी प्रतिक्रिया प्रतीक्षित है", status_accepted: "स्वीकृत", status_declined: "अस्वीकृत", eyebrow: "सहमति अनुरोध" },
  bn: { hello: "নমস্কার {name},", thanks: "ধন্যবাদ — আপনি আগ্রহী।", consent_type: "সম্মতির ধরন:", consent_version: "সম্মতির সংস্করণ:", id_proof: "পরিচয়পত্র:", not_provided: "প্রদান করা হয়নি", accept: "গ্রহণ করুন", decline: "প্রত্যাখ্যান করুন", fallback_link_note: "উপরের বোতামগুলি কাজ না করলে, এই লিঙ্কটি কপি করে আপনার ব্রাউজারে পেস্ট করুন:", accept_label: "গ্রহণ:", decline_label: "প্রত্যাখ্যান:", best_regards: "শুভেচ্ছাসহ,", info_only: "এই বার্তাটি শুধুমাত্র তথ্যের জন্য এবং এতে প্রতিক্রিয়া বোতাম নেই।", status_pending: "আপনার প্রতিক্রিয়ার অপেক্ষায়", status_accepted: "গৃহীত", status_declined: "প্রত্যাখ্যাত", eyebrow: "সম্মতি অনুরোধ" },
  as: { hello: "নমস্কাৰ {name},", thanks: "ধন্যবাদ — আপুনি আগ্ৰহী।", consent_type: "সন্মতিৰ প্ৰকাৰ:", consent_version: "সন্মতিৰ সংস্কৰণ:", id_proof: "পৰিচয় প্ৰমাণ:", not_provided: "প্ৰদান কৰা হোৱা নাই", accept: "গ্ৰহণ কৰক", decline: "প্ৰত্যাখ্যান কৰক", fallback_link_note: "ওপৰৰ বুটামসমূহে কাম নকৰিলে, এই লিংকটো কপি কৰি আপোনাৰ ব্ৰাউজাৰত পেষ্ট কৰক:", accept_label: "গ্ৰহণ:", decline_label: "প্ৰত্যাখ্যান:", best_regards: "শুভেচ্ছাৰেৰে,", info_only: "এই বাৰ্তাটো কেৱল তথ্যৰ বাবে আৰু ইয়াত প্ৰতিক্ৰিয়া বুটাম নাই।", status_pending: "আপোনাৰ সঁহাৰি বাকী আছে", status_accepted: "গৃহীত", status_declined: "প্ৰত্যাখ্যাত", eyebrow: "সন্মতিৰ অনুৰোধ" },
  gu: { hello: "નમસ્તે {name},", thanks: "આભાર — તમે રસ ધરાવો છો.", consent_type: "સંમતિ પ્રકાર:", consent_version: "સંમતિ આવૃત્તિ:", id_proof: "ઓળખ પુરાવો:", not_provided: "પ્રદાન કરેલ નથી", accept: "સ્વીકારો", decline: "નકારો", fallback_link_note: "જો ઉપરના બટન કામ ન કરે, તો આ લિંક કૉપિ કરીને તમારા બ્રાઉઝરમાં પેસ્ટ કરો:", accept_label: "સ્વીકારો:", decline_label: "નકારો:", best_regards: "શુભેચ્છાઓ સહ,", info_only: "આ સંદેશ ફક્ત તમારી માહિતી માટે છે અને તેમાં પ્રતિભાવ બટન નથી.", status_pending: "તમારા પ્રતિભાવની રાહ છે", status_accepted: "સ્વીકૃત", status_declined: "નકારેલ", eyebrow: "સંમતિ વિનંતી" },
  kn: { hello: "ನಮಸ್ಕಾರ {name},", thanks: "ಧನ್ಯವಾದಗಳು — ನೀವು ಆಸಕ್ತಿ ಹೊಂದಿದ್ದೀರಿ.", consent_type: "ಒಪ್ಪಿಗೆಯ ಪ್ರಕಾರ:", consent_version: "ಒಪ್ಪಿಗೆ ಆವೃತ್ತಿ:", id_proof: "ಗುರುತಿನ ಪುರಾವೆ:", not_provided: "ಒದಗಿಸಿಲ್ಲ", accept: "ಒಪ್ಪಿಕೊಳ್ಳಿ", decline: "ತಿರಸ್ಕರಿಸಿ", fallback_link_note: "ಮೇಲಿನ ಬಟನ್‌ಗಳು ಕೆಲಸ ಮಾಡದಿದ್ದರೆ, ಈ ಲಿಂಕ್ ಅನ್ನು ನಕಲಿಸಿ ನಿಮ್ಮ ಬ್ರೌಸರ್‌ನಲ್ಲಿ ಅಂಟಿಸಿ:", accept_label: "ಒಪ್ಪಿಗೆ:", decline_label: "ತಿರಸ್ಕಾರ:", best_regards: "ವಂದನೆಗಳೊಂದಿಗೆ,", info_only: "ಈ ಸಂದೇಶ ಕೇವಲ ಮಾಹಿತಿಗಾಗಿ ಮಾತ್ರ, ಇದರಲ್ಲಿ ಪ್ರತಿಕ್ರಿಯೆ ಬಟನ್‌ಗಳಿಲ್ಲ.", status_pending: "ನಿಮ್ಮ ಪ್ರತಿಕ್ರಿಯೆಗಾಗಿ ಕಾಯಲಾಗುತ್ತಿದೆ", status_accepted: "ಒಪ್ಪಿಗೆ ನೀಡಲಾಗಿದೆ", status_declined: "ತಿರಸ್ಕರಿಸಲಾಗಿದೆ", eyebrow: "ಒಪ್ಪಿಗೆ ವಿನಂತಿ" },
  ks: { hello: "اسلام علیکم {name},", thanks: "شکریہ — توہہ دلچسپی ظاہر کرنہ آمت۔", consent_type: "رضامندی قسم:", consent_version: "رضامندی ورجن:", id_proof: "شناختی ثبوت:", not_provided: "فراہم کرنہ آمت نہٕ", accept: "منظور", decline: "رد", fallback_link_note: "اگر پؠٹھِ بٹن کٲم نہٕ کران، تہٕ یہ لنک اپنہٕ براؤزرس منز پیسٹ کریو:", accept_label: "منظور:", decline_label: "رد:", best_regards: "نیک خواہشات ساں,", info_only: "یہ پیغام صرف معلومات خٲطرٕ چھُ تہٕ اس منز جواب بٹن چھُ نہٕ۔", status_pending: "توہندس جوابس منتظر", status_accepted: "منظور کرنہ آمت", status_declined: "رد کرنہ آمت", eyebrow: "رضامندی درخواست", rtl: true },
  kok: { hello: "नमस्कार {name},", thanks: "देव बरें करूं — तुमी उत्सुक आसात.", consent_type: "संमती प्रकार:", consent_version: "संमती आवृत्ती:", id_proof: "वळख पुरावो:", not_provided: "दिलो ना", accept: "मान्य करात", decline: "न्हयकारात", fallback_link_note: "वयल्या बटणां काम करिनात जाल्यार, हो लिंक कॉपी करून तुमच्या ब्राऊझरांत पेस्ट करात:", accept_label: "मान्य:", decline_label: "न्हयकार:", best_regards: "बरे मनोकामनांसयत,", info_only: "हो संदेश फकत माहितीखातीर आसा आनी ह्यांत जबाब बटणां ना.", status_pending: "तुमच्या जबाबाची वाट पळयता", status_accepted: "मान्य केलां", status_declined: "न्हयकारलां", eyebrow: "संमती विनंती" },
  ml: { hello: "നമസ്കാരം {name},", thanks: "നന്ദി — നിങ്ങൾക്ക് താൽപ്പര്യമുണ്ട്.", consent_type: "സമ്മത തരം:", consent_version: "സമ്മത പതിപ്പ്:", id_proof: "തിരിച്ചറിയൽ രേഖ:", not_provided: "നൽകിയിട്ടില്ല", accept: "അംഗീകരിക്കുക", decline: "നിരസിക്കുക", fallback_link_note: "മുകളിലുള്ള ബട്ടണുകൾ പ്രവർത്തിക്കുന്നില്ലെങ്കിൽ, ഈ ലിങ്ക് പകർത്തി നിങ്ങളുടെ ബ്രൗസറിൽ ഒട്ടിക്കുക:", accept_label: "അംഗീകാരം:", decline_label: "നിരസിക്കൽ:", best_regards: "ആശംസകളോടെ,", info_only: "ഈ സന്ദേശം വിവരത്തിന് മാത്രമുള്ളതാണ്, പ്രതികരണ ബട്ടണുകൾ ഉൾപ്പെടുന്നില്ല.", status_pending: "നിങ്ങളുടെ പ്രതികരണം കാത്തിരിക്കുന്നു", status_accepted: "അംഗീകരിച്ചു", status_declined: "നിരസിച്ചു", eyebrow: "സമ്മത അഭ്യർത്ഥന" },
  mai: { hello: "प्रणाम {name},", thanks: "धन्यवाद — अहाँ आग्रही छी।", consent_type: "सहमति प्रकार:", consent_version: "सहमति संस्करण:", id_proof: "पहिचान प्रमाण:", not_provided: "उपलब्ध नहि कयल गेल", accept: "स्वीकार करू", decline: "अस्वीकार करू", fallback_link_note: "जँ ऊपर देल बटन काज नहि करैत अछि, त' ई लिंक कॉपी कऽ अपन ब्राउज़र मे पेस्ट करू:", accept_label: "स्वीकार:", decline_label: "अस्वीकार:", best_regards: "सादर,", info_only: "ई संदेश केवल जानकारीक लेल अछि आ एहिमे प्रतिक्रिया बटन नहि अछि।", status_pending: "अहाँक प्रतिक्रियाक प्रतीक्षा", status_accepted: "स्वीकृत", status_declined: "अस्वीकृत", eyebrow: "सहमति आग्रह" },
  mni: { hello: "ꯈꯨꯔꯨꯝꯖꯔꯤ {name},", thanks: "ꯊꯉꯒꯠꯆꯔꯤ — ꯅꯪꯅ ꯃꯔꯨ ꯑꯣꯏꯅ ꯋꯥꯔꯤ ꯍꯦꯟꯅ ꯄꯤ.", consent_type: "ꯍꯦꯛꯅꯤꯡꯒꯤ ꯃꯈꯜ:", consent_version: "ꯍꯦꯛꯅꯤꯡꯒꯤ ꯚꯔꯁꯟ:", id_proof: "ꯏꯗꯦꯟꯇꯤꯇꯤꯒꯤ ꯄ꯭ꯔꯨꯐ:", not_provided: "ꯄꯤꯗ꯭ꯔꯦ", accept: "ꯌꯥꯗꯦ", decline: "ꯌꯥꯗꯦ", fallback_link_note: "ꯃꯊꯛꯀꯤ ꯕꯇꯟꯅ ꯊꯧꯗꯅ ꯑꯣꯏꯔꯕꯗꯤ, ꯃꯁꯤ link ꯑꯗꯨ copy ꯇꯧꯒꯗꯕꯅꯤ browser ꯗ paste ꯇꯧꯕꯤꯌꯨ:", accept_label: "ꯌꯥꯗꯦ:", decline_label: "ꯌꯥꯗꯦ:", best_regards: "ꯋꯥꯍꯩꯁꯤꯡꯅ,", info_only: "ꯃꯁꯤ ꯄꯥꯎ ꯅ ꯖ ꯐꯣꯡꯗꯣꯛꯅꯕꯅꯤ ꯑꯃꯁꯨꯡ ꯃꯁꯤꯗ ꯄ꯭ꯔꯤꯇꯤꯛꯔꯤꯌꯥ ꯕꯇꯟ ꯌꯥꯎꯗꯦ.", status_pending: "ꯉꯁꯤꯒꯤ ꯄꯨꯛꯅꯤꯡ ꯉꯥꯏꯔꯤ", status_accepted: "ꯌꯥꯗꯦ", status_declined: "ꯌꯥꯗꯦ", eyebrow: "ꯍꯦꯛꯅꯤꯡꯒꯤ ꯑꯐꯍꯥꯕ" },
  mr: { hello: "नमस्कार {name},", thanks: "धन्यवाद — तुम्हाला स्वारस्य आहे.", consent_type: "संमती प्रकार:", consent_version: "संमती आवृत्ती:", id_proof: "ओळख पुरावा:", not_provided: "प्रदान केलेले नाही", accept: "स्वीकारा", decline: "नकारा", fallback_link_note: "वरील बटणे काम करत नसतील, तर ही लिंक कॉपी करून तुमच्या ब्राउझरमध्ये पेस्ट करा:", accept_label: "स्वीकारा:", decline_label: "नकारा:", best_regards: "आदरपूर्वक,", info_only: "हा संदेश केवळ माहितीसाठी आहे आणि यात प्रतिसाद बटणे समाविष्ट नाहीत.", status_pending: "तुमच्या प्रतिसादाची प्रतीक्षा आहे", status_accepted: "स्वीकारले", status_declined: "नाकारले", eyebrow: "संमती विनंती" },
  ne: { hello: "नमस्ते {name},", thanks: "धन्यवाद — तपाईं इच्छुक हुनुहुन्छ।", consent_type: "सहमति प्रकार:", consent_version: "सहमति संस्करण:", id_proof: "परिचय प्रमाण:", not_provided: "उपलब्ध गराइएको छैन", accept: "स्वीकार गर्नुहोस्", decline: "अस्वीकार गर्नुहोस्", fallback_link_note: "यदि माथिका बटनहरूले काम गर्दैनन् भने, यो लिङ्क कपी गरी आफ्नो ब्राउजरमा पेस्ट गर्नुहोस्:", accept_label: "स्वीकार:", decline_label: "अस्वीकार:", best_regards: "शुभकामना सहित,", info_only: "यो सन्देश जानकारीको लागि मात्र हो र यसमा प्रतिक्रिया बटनहरू छैनन्।", status_pending: "तपाईंको प्रतिक्रिया कुरिँदै", status_accepted: "स्वीकृत", status_declined: "अस्वीकृत", eyebrow: "सहमति अनुरोध" },
  or: { hello: "ନମସ୍କାର {name},", thanks: "ଧନ୍ୟବାଦ — ଆପଣ ଆଗ୍ରହୀ।", consent_type: "ସମ୍ମତି ପ୍ରକାର:", consent_version: "ସମ୍ମତି ସଂସ୍କରଣ:", id_proof: "ପରିଚୟ ପ୍ରମାଣ:", not_provided: "ପ୍ରଦାନ କରାଯାଇ ନାହିଁ", accept: "ଗ୍ରହଣ କରନ୍ତୁ", decline: "ପ୍ରତ୍ୟାଖ୍ୟାନ କରନ୍ତୁ", fallback_link_note: "ଉପରୋକ୍ତ ବଟନଗୁଡ଼ିକ କାମ ନକଲେ, ଏହି ଲିଙ୍କକୁ କପି କରି ଆପଣଙ୍କ ବ୍ରାଉଜରରେ ପେଷ୍ଟ କରନ୍ତୁ:", accept_label: "ଗ୍ରହଣ:", decline_label: "ପ୍ରତ୍ୟାଖ୍ୟାନ:", best_regards: "ଶୁଭେଚ୍ଛା ସହ,", info_only: "ଏହି ବାର୍ତ୍ତା କେବଳ ସୂଚନା ପାଇଁ ଏବଂ ଏଥିରେ ପ୍ରତିକ୍ରିୟା ବଟନ ନାହିଁ।", status_pending: "ଆପଣଙ୍କ ପ୍ରତିକ୍ରିୟା ଅପେକ୍ଷାରେ", status_accepted: "ଗୃହୀତ", status_declined: "ପ୍ରତ୍ୟାଖ୍ୟାତ", eyebrow: "ସମ୍ମତି ଅନୁରୋଧ" },
  pa: { hello: "ਸਤ ਸ੍ਰੀ ਅਕਾਲ {name},", thanks: "ਧੰਨਵਾਦ — ਤੁਸੀਂ ਦਿਲਚਸਪੀ ਰੱਖਦੇ ਹੋ।", consent_type: "ਸਹਿਮਤੀ ਦੀ ਕਿਸਮ:", consent_version: "ਸਹਿਮਤੀ ਸੰਸਕਰਣ:", id_proof: "ਪਛਾਣ ਸਬੂਤ:", not_provided: "ਪ੍ਰਦਾਨ ਨਹੀਂ ਕੀਤਾ ਗਿਆ", accept: "ਸਵੀਕਾਰ ਕਰੋ", decline: "ਅਸਵੀਕਾਰ ਕਰੋ", fallback_link_note: "ਜੇ ਉਪਰੋਕਤ ਬਟਨ ਕੰਮ ਨਹੀਂ ਕਰਦੇ, ਤਾਂ ਇਸ ਲਿੰਕ ਨੂੰ ਕਾਪੀ ਕਰਕੇ ਆਪਣੇ ਬ੍ਰਾਊਜ਼ਰ ਵਿੱਚ ਪੇਸਟ ਕਰੋ:", accept_label: "ਸਵੀਕਾਰ:", decline_label: "ਅਸਵੀਕਾਰ:", best_regards: "ਸ਼ੁਭਕਾਮਨਾਵਾਂ ਸਹਿਤ,", info_only: "ਇਹ ਸੁਨੇਹਾ ਸਿਰਫ਼ ਜਾਣਕਾਰੀ ਲਈ ਹੈ ਅਤੇ ਇਸ ਵਿੱਚ ਜਵਾਬ ਬਟਨ ਸ਼ਾਮਲ ਨਹੀਂ ਹਨ।", status_pending: "ਤੁਹਾਡੇ ਜਵਾਬ ਦੀ ਉਡੀਕ ਹੈ", status_accepted: "ਸਵੀਕਾਰ ਕੀਤਾ", status_declined: "ਅਸਵੀਕਾਰ ਕੀਤਾ", eyebrow: "ਸਹਿਮਤੀ ਬੇਨਤੀ" },
  sa: { hello: "नमस्ते {name},", thanks: "धन्यवादः — भवान् रुचिं दर्शितवान्।", consent_type: "सम्मति-प्रकारः:", consent_version: "सम्मति-संस्करणम्:", id_proof: "परिचय-प्रमाणम्:", not_provided: "न प्रदत्तम्", accept: "स्वीकुर्वन्तु", decline: "अस्वीकुर्वन्तु", fallback_link_note: "यदि उपरितनानि बटनानि न कार्यं कुर्वन्ति, तर्हि एतत् लिङ्कं प्रतिलिप्य स्व-ब्राउज़रे संलग्नयन्तु:", accept_label: "स्वीकारः:", decline_label: "अस्वीकारः:", best_regards: "शुभाशयैः सह,", info_only: "एतत् सन्देशः केवलं सूचनार्थम् अस्ति, अत्र प्रतिक्रिया-बटनानि न सन्ति।", status_pending: "भवतः प्रतिक्रिया प्रतीक्ष्यते", status_accepted: "स्वीकृतम्", status_declined: "अस्वीकृतम्", eyebrow: "सम्मति-अनुरोधः" },
  sat: { hello: "ᱡᱚᱦᱟᱨ {name},", thanks: "ᱥᱟᱨᱦᱟᱣ — ᱟᱢ ᱨᱟᱹᱥᱠᱟ ᱢᱮᱱᱟᱢᱟ.", consent_type: "ᱥᱚᱢᱚᱛᱤ ᱞᱮᱠᱟᱱ:", consent_version: "ᱥᱚᱢᱚᱛᱤ ᱵᱷᱟᱨᱥᱚᱱ:", id_proof: "ᱯᱚᱨᱤᱪᱟᱭ ᱞᱮᱠᱷᱟ:", not_provided: "ᱟᱠᱟᱱ ᱟᱠᱟᱱᱟᱭ", accept: "ᱢᱟᱱᱟ ᱢᱮ", decline: "ᱵᱟᱹᱰ ᱢᱮ", fallback_link_note: "ᱪᱮᱫ ᱪᱮᱛᱟᱱ ᱵᱚᱴᱚᱱ ᱠᱳ ᱠᱟᱹᱢᱤ ᱵᱟᱭ ᱠᱟᱛᱮ, ᱚᱱᱟ ᱞᱤᱝᱠ ᱠᱚᱯᱤ ᱠᱟᱛᱮ ᱟᱢᱟᱜ ᱵᱨᱟᱣᱡᱚᱨ ᱨᱮ ᱯᱮᱥᱴ ᱢᱮ:", accept_label: "ᱢᱟᱱᱟ:", decline_label: "ᱵᱟᱹᱰ:", best_regards: "ᱥᱟᱨᱦᱟᱣ ᱥᱟᱶᱛᱮ,", info_only: "ᱱᱚᱶᱟ ᱠᱷᱚᱵᱚᱨ ᱚᱠᱛᱟᱭ ᱵᱟᱨᱛᱟ ᱞᱟᱹᱜᱤᱫ ᱠᱟᱱᱟ ᱟᱨ ᱚᱱᱟᱨᱮ ᱡᱟᱣᱟᱵ ᱵᱚᱴᱚᱱ ᱵᱟᱹᱱᱩᱜᱼᱟᱭ।", status_pending: "ᱟᱢᱟᱜ ᱡᱟᱣᱟᱵ ᱱᱮᱲᱟ ᱠᱟᱱᱟ", status_accepted: "ᱢᱟᱱᱟ ᱮᱱᱟ", status_declined: "ᱵᱟᱹᱰ ᱮᱱᱟ", eyebrow: "ᱥᱚᱢᱚᱛᱤ ᱟᱹᱨᱡᱤ" },
  sd: { hello: "سلام {name},", thanks: "مهرباني — توهان دلچسپي ظاهر ڪئي آهي.", consent_type: "رضامندي جو قسم:", consent_version: "رضامندي ورجن:", id_proof: "سڃاڻپ جو ثبوت:", not_provided: "مهيا نه ڪيل", accept: "قبول ڪريو", decline: "رد ڪريو", fallback_link_note: "جيڪڏهن مٿيان بٽڻ ڪم نه ڪن ته، هي لنڪ ڪاپي ڪري پنهنجي برائوزر ۾ پيسٽ ڪريو:", accept_label: "قبول:", decline_label: "رد:", best_regards: "نيڪ خواهشن سان,", info_only: "هي پيغام صرف ڄاڻ لاءِ آهي ۽ ان ۾ جواب بٽڻ شامل نه آهن.", status_pending: "توهان جي جواب جو انتظار", status_accepted: "قبول ٿيل", status_declined: "رد ٿيل", eyebrow: "رضامندي جي درخواست", rtl: true },
  ta: { hello: "வணக்கம் {name},", thanks: "நன்றி — நீங்கள் ஆர்வமாக உள்ளீர்கள்.", consent_type: "ஒப்புதல் வகை:", consent_version: "ஒப்புதல் பதிப்பு:", id_proof: "அடையாள சான்று:", not_provided: "வழங்கப்படவில்லை", accept: "ஏற்றுக்கொள்", decline: "நிராகரி", fallback_link_note: "மேலே உள்ள பொத்தான்கள் வேலை செய்யாவிட்டால், இந்த இணைப்பை நகலெடுத்து உங்கள் உலாவியில் ஒட்டவும்:", accept_label: "ஏற்பு:", decline_label: "நிராகரிப்பு:", best_regards: "அன்புடன்,", info_only: "இந்த செய்தி தகவலுக்காக மட்டுமே வழங்கப்படுகிறது, இதில் பதில் பொத்தான்கள் இல்லை.", status_pending: "உங்கள் பதிலுக்காக காத்திருக்கிறது", status_accepted: "ஏற்கப்பட்டது", status_declined: "நிராகரிக்கப்பட்டது", eyebrow: "ஒப்புதல் கோரிக்கை" },
  te: { hello: "నమస్కారం {name},", thanks: "ధన్యవాదాలు — మీరు ఆసక్తి కలిగి ఉన్నారు.", consent_type: "సమ్మతి రకం:", consent_version: "సమ్మతి వెర్షన్:", id_proof: "గుర్తింపు రుజువు:", not_provided: "అందించబడలేదు", accept: "అంగీకరించండి", decline: "తిరస్కరించండి", fallback_link_note: "పైన ఉన్న బటన్‌లు పని చేయకపోతే, ఈ లింక్‌ను కాపీ చేసి మీ బ్రౌజర్‌లో పేస్ట్ చేయండి:", accept_label: "అంగీకారం:", decline_label: "తిరస్కారం:", best_regards: "శుభాకాంక్షలతో,", info_only: "ఈ సందేశం సమాచార ప్రయోజనం కోసం మాత్రమే మరియు దీనిలో ప్రతిస్పందన బటన్‌లు లేవు.", status_pending: "మీ ప్రతిస్పందన కోసం వేచి ఉంది", status_accepted: "అంగీకరించారు", status_declined: "తిరస్కరించారు", eyebrow: "సమ్మతి అభ్యర్థన" },
  ur: { hello: "السلام علیکم {name},", thanks: "شکریہ — آپ دلچسپی رکھتے ہیں۔", consent_type: "رضامندی کی قسم:", consent_version: "رضامندی ورژن:", id_proof: "شناختی ثبوت:", not_provided: "فراہم نہیں کیا گیا", accept: "قبول کریں", decline: "مسترد کریں", fallback_link_note: "اگر اوپر دیے گئے بٹن کام نہ کریں تو یہ لنک کاپی کر کے اپنے براؤزر میں پیسٹ کریں:", accept_label: "قبول:", decline_label: "مسترد:", best_regards: "نیک تمناؤں کے ساتھ,", info_only: "یہ پیغام صرف معلومات کے لیے ہے اور اس میں جواب کے بٹن شامل نہیں ہیں۔", status_pending: "آپ کے جواب کا انتظار ہے", status_accepted: "قبول کر لیا گیا", status_declined: "مسترد کر دیا گیا", eyebrow: "رضامندی کی درخواست", rtl: true },
  brx: { hello: "जोहार {name},", thanks: "धन्यबाद — नोंथाङा सोलोखानाय दं।", consent_type: "मानसिनाय राहा:", consent_version: "मानसिनाय भार्सन:", id_proof: "फिनायथाव प्रमाण:", not_provided: "होबाय जायाखै", accept: "मानो", decline: "मानाखै", fallback_link_note: "गुबुन बटनफोरा काम खालामाखैयोब्ला, बे लिंकखौ कपि खालामनानै नोंथाङनि ब्राउजारजों पेष्ट खालामो:", accept_label: "मानो:", decline_label: "मानाखै:", best_regards: "गोबां सानो,", info_only: "बे सोदोबखौ नुनाय गंसेनोखर हरखानाय जायो, आरो बेयो जबाब बटन गैया।", status_pending: "नोंथाङनि जबाबखौ नेंगारो", status_accepted: "मानो जानाय", status_declined: "मानाखै जानाय", eyebrow: "मानसिनाय राहा दावा" },
  doi: { hello: "नमस्ते {name},", thanks: "धन्यवाद — तुसां रुचि रखदे ओ।", consent_type: "सहमति किस्म:", consent_version: "सहमति संस्करण:", id_proof: "पछाण सबूत:", not_provided: "मुहैया नेईं करेआ गेआ", accept: "स्वीकार करो", decline: "अस्वीकार करो", fallback_link_note: "जेकर उप्पर दित्ते गेदे बटन काम नेईं करदे, तां इस लिंक गी कॉपी करियै अपने ब्राउज़र च पेस्ट करो:", accept_label: "स्वीकार:", decline_label: "अस्वीकार:", best_regards: "शुभकामनाएं सहित,", info_only: "एह् संदेश सिर्फ जानकारी आस्तै ऐ ते इस च जवाब बटन शामल नेईं न।", status_pending: "तुंहाडे जवाब दी उडीक", status_accepted: "स्वीकार होई गेआ", status_declined: "अस्वीकार होई गेआ", eyebrow: "सहमति बेनती" },
};

const LANGUAGE_NAMES = {
  en: "English", hi: "हिन्दी", bn: "বাংলা", as: "অসমীয়া", gu: "ગુજરાતી",
  kn: "ಕನ್ನಡ", ks: "کٲشُر", kok: "कोंकणी", ml: "മലയാളം", mai: "मैथिली",
  mni: "মৈতৈলোন্", mr: "मराठी", ne: "नेपाली", or: "ଓଡ଼ିଆ", pa: "ਪੰਜਾਬੀ",
  sa: "संस्कृतम्", sat: "ᱥᱟᱱᱛᱟᱲᱤ", sd: "سنڌي", ta: "தமிழ்", te: "తెలుగు",
  ur: "اردو", brx: "बड़ो", doi: "डोगरी",
};

const DEFAULT_LANG = "en";
const getStrings = (lang) => TRANSLATIONS[lang] || TRANSLATIONS[DEFAULT_LANG];
export { getStrings, LANGUAGE_NAMES, TRANSLATIONS };

/* ------------------------------------------------------------------
   2. The consent widget — a live component you call directly, instead
      of generating an HTML email. Fires onAccept / onDecline with a
      signed decision record you can post to your consent API.
------------------------------------------------------------------- */
export default function ConsentWidget({
  initialLang = "hi",
  displayName = "Rohit",
  consentType = "Marketing Communications",
  bodyContent = "We would like to send you product updates, offers, and service notices by email, SMS, and WhatsApp.",
  version = "v2.1",
  idProofFile = null,
  privacyNoticeRow = true,
  includeResponseLinks = true,
  tenantName = "Acme Pvt Ltd",
  onAccept,
  onDecline,
}) {
  const [lang, setLang] = useState(initialLang);
  const [decision, setDecision] = useState(null); // null | "accepted" | "declined"
  const [pulse, setPulse] = useState(false);
  const liveRef = useRef(null);

  const t = useMemo(() => getStrings(lang), [lang]);
  const rtl = !!t.rtl;
  const helloLine = t.hello.replace("{name}", displayName);

  useEffect(() => {
    if (decision && liveRef.current) liveRef.current.focus();
  }, [decision]);

  const record = () => ({
    lang,
    consentType,
    version,
    timestamp: new Date().toISOString(),
  });

  const handleAccept = () => {
    setDecision("accepted");
    setPulse(true);
    onAccept && onAccept(record());
  };
  const handleDecline = () => {
    setDecision("declined");
    setPulse(true);
    onDecline && onDecline(record());
  };

  return (
    <div style={{ ...styles.page, direction: rtl ? "rtl" : "ltr" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,500;9..144,600&family=Inter:wght@400;500;600&display=swap');
        .cw-seal { transition: transform .5s cubic-bezier(.2,1.4,.4,1), opacity .4s ease; }
        .cw-seal.stamped { animation: cw-stamp .45s cubic-bezier(.2,1.6,.4,1); }
        @keyframes cw-stamp {
          0% { transform: scale(2.4) rotate(-14deg); opacity: 0; }
          60% { transform: scale(.92) rotate(-14deg); opacity: 1; }
          100% { transform: scale(1) rotate(-14deg); opacity: 1; }
        }
        .cw-btn { transition: transform .15s ease, box-shadow .15s ease, filter .15s ease; }
        .cw-btn:hover { transform: translateY(-1px); filter: brightness(1.04); }
        .cw-btn:active { transform: translateY(0); }
        .cw-btn:focus-visible { outline: 2px solid #1F2E2C; outline-offset: 3px; }
        .cw-select:focus-visible { outline: 2px solid #1F2E2C; outline-offset: 2px; }
        @media (prefers-reduced-motion: reduce) {
          .cw-seal, .cw-seal.stamped, .cw-btn { animation: none !important; transition: none !important; }
        }
      `}</style>

      <div style={styles.card}>
        {/* Letterhead */}
        <div style={styles.letterhead}>
          <div>
            <div style={styles.tenant}>{tenantName}</div>
            <div style={styles.eyebrow}>{t.eyebrow}</div>
          </div>

          <select
            className="cw-select"
            value={lang}
            onChange={(e) => setLang(e.target.value)}
            style={styles.langSelect}
            aria-label="Language"
          >
            {Object.keys(TRANSLATIONS).map((code) => (
              <option key={code} value={code}>{LANGUAGE_NAMES[code]}</option>
            ))}
          </select>
        </div>

        {/* Seal / status stamp */}
        <div style={styles.sealRow}>
          <div
            className={`cw-seal ${decision ? "stamped" : ""}`}
            style={{
              ...styles.seal,
              borderColor: decision === "accepted" ? COLORS.accept : decision === "declined" ? COLORS.decline : COLORS.marigold,
              color: decision === "accepted" ? COLORS.accept : decision === "declined" ? COLORS.decline : COLORS.marigold,
              transform: "rotate(-14deg)",
            }}
          >
            <span style={styles.sealText}>
              {decision === "accepted" ? t.status_accepted : decision === "declined" ? t.status_declined : t.status_pending}
            </span>
          </div>
        </div>

        {/* Body */}
        <div style={{ padding: "4px 32px 0" }}>
          <p style={styles.hello}>{helloLine}</p>
          <p style={styles.body}>{t.thanks}</p>

          <div style={styles.fieldRow}>
            <span style={styles.fieldLabel}>{t.consent_type}</span>
            <strong style={styles.fieldValue}>{consentType}</strong>
          </div>
          <div style={styles.fieldRow}>
            <span style={styles.fieldLabel}>{t.consent_version}</span>
            <span style={styles.fieldValue}>{version}</span>
          </div>
          {privacyNoticeRow && (
            <div style={styles.fieldRow}>
              <span style={styles.fieldLabel}>{t.id_proof}</span>
              <span style={styles.fieldValue}>{idProofFile || t.not_provided}</span>
            </div>
          )}

          <p style={{ ...styles.body, marginTop: 18 }}>{bodyContent}</p>
        </div>

        {/* Actions */}
        {includeResponseLinks ? (
          <div style={styles.actions}>
            <button
              className="cw-btn"
              onClick={handleAccept}
              disabled={!!decision}
              style={{ ...styles.btn, background: COLORS.accept, opacity: decision && decision !== "accepted" ? 0.45 : 1 }}
            >
              {t.accept}
            </button>
            <button
              className="cw-btn"
              onClick={handleDecline}
              disabled={!!decision}
              style={{ ...styles.btn, background: COLORS.decline, opacity: decision && decision !== "declined" ? 0.45 : 1 }}
            >
              {t.decline}
            </button>
          </div>
        ) : (
          !privacyNoticeRow && <p style={styles.infoOnly}>{t.info_only}</p>
        )}

        <div
          ref={liveRef}
          role="status"
          aria-live="polite"
          tabIndex={-1}
          style={styles.liveRegion}
        >
          {decision === "accepted" && `${t.status_accepted}.`}
          {decision === "declined" && `${t.status_declined}.`}
        </div>

        <div style={styles.footer}>
          <span>{t.best_regards}</span>
          <span style={{ fontWeight: 600 }}>{tenantName}</span>
        </div>
      </div>
    </div>
  );
}

/* ------------------------------------------------------------------
   3. Tokens & styles
------------------------------------------------------------------- */
const COLORS = {
  bg: "#EAE4D6",
  card: "#FBF9F3",
  ink: "#1F2E2C",
  inkSoft: "#5A6663",
  hair: "#DED6C2",
  marigold: "#C97F1E",
  accept: "#3D7A56",
  decline: "#A6462E",
};

const styles = {
  page: {
    minHeight: "100%",
    background: COLORS.bg,
    padding: "40px 16px",
    display: "flex",
    justifyContent: "center",
    fontFamily: "'Inter', system-ui, -apple-system, 'Noto Sans', sans-serif",
    color: COLORS.ink,
  },
  card: {
    width: "100%",
    maxWidth: 480,
    background: COLORS.card,
    borderRadius: 4,
    border: `1px solid ${COLORS.hair}`,
    boxShadow: "0 1px 2px rgba(31,46,42,0.06), 0 12px 32px -16px rgba(31,46,42,0.25)",
    overflow: "hidden",
  },
  letterhead: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    padding: "24px 32px 16px",
    borderBottom: `1px solid ${COLORS.hair}`,
  },
  tenant: {
    fontFamily: "'Fraunces', serif",
    fontWeight: 600,
    fontSize: 18,
    letterSpacing: "-0.01em",
  },
  eyebrow: {
    marginTop: 4,
    fontSize: 11,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: COLORS.inkSoft,
  },
  langSelect: {
    fontSize: 12,
    padding: "6px 8px",
    borderRadius: 4,
    border: `1px solid ${COLORS.hair}`,
    background: "#fff",
    color: COLORS.ink,
    cursor: "pointer",
  },
  sealRow: {
    display: "flex",
    justifyContent: "center",
    marginTop: 20,
  },
  seal: {
    width: 92,
    height: 92,
    borderRadius: "50%",
    border: "2.5px solid",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 8,
    background: "#fff",
  },
  sealText: {
    fontFamily: "'Fraunces', serif",
    fontSize: 11,
    fontWeight: 600,
    textAlign: "center",
    lineHeight: 1.25,
    letterSpacing: "0.01em",
  },
  hello: {
    fontFamily: "'Fraunces', serif",
    fontSize: 17,
    fontWeight: 600,
    margin: "20px 0 8px",
  },
  body: {
    fontSize: 14.5,
    lineHeight: 1.6,
    color: COLORS.ink,
    margin: "0 0 6px",
  },
  fieldRow: {
    display: "flex",
    gap: 8,
    fontSize: 13.5,
    padding: "6px 0",
    borderBottom: `1px solid ${COLORS.hair}`,
  },
  fieldLabel: { color: COLORS.inkSoft, minWidth: 130 },
  fieldValue: { color: COLORS.ink },
  actions: {
    display: "flex",
    gap: 12,
    padding: "24px 32px 8px",
  },
  btn: {
    flex: 1,
    border: "none",
    borderRadius: 6,
    color: "#fff",
    fontSize: 14,
    fontWeight: 600,
    padding: "12px 16px",
    cursor: "pointer",
  },
  infoOnly: {
    margin: "18px 32px 8px",
    fontSize: 12,
    color: COLORS.inkSoft,
  },
  liveRegion: {
    position: "absolute",
    width: 1,
    height: 1,
    overflow: "hidden",
    clip: "rect(0 0 0 0)",
  },
  footer: {
    display: "flex",
    justifyContent: "space-between",
    padding: "20px 32px 28px",
    fontSize: 13,
    color: COLORS.inkSoft,
  },
};